import { $_DKD, $_GCD, $_CD } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";

export default {
    state: {
        logoFile: {},
        pageNm: '',
        pageCate: '',
        isLoader: false,
        windowWidthSize: window.innerWidth,
        showBtm: true,
    },
    getters: {
        getLogoFile: function(state) {
            return state.logoFile;
        },
        getPageNm: function(state) {
            return state.pageNm;
        },
        getPageCate: function(state) {
            return state.pageCate;
        },
        getIsLoader: function(state) {
            return state.isLoader;
        },
        getWindowWidthSize: function(state) {
            return state.windowWidthSize;
        },
        getShowBtm: function(state) {
            return state.showBtm;
        },
    },
    mutations: {
        LOGO_FILE(state, logoFile) {
            state.logoFile = logoFile;
        },
        PAGE_NM(state, pageNm) {
            state.pageNm = pageNm;
        },
        PAGE_CATE(state, pageCate) {
            state.pageCate = pageCate;
        },
        IS_LOADER(state, isLoader) {
            state.isLoader = isLoader;
        },
        WINDOW_WIDTH_SIZE(state, windowWidthSize) {
            state.windowWidthSize = windowWidthSize;
        },
        SHOW_BTM(state, showBtm) {
            state.showBtm = showBtm;
        },
    },
    actions : {
        FETCH_LOGO_FILE({commit}) {

            let now = new Date();
            now.setDate(now.getDate() - 0);
            let nowStr = now.format('yyyyMMdd');
            return commonApi.fetchRepoDataList($_DKD.LOGO, 'searchFromDate=' + nowStr + '&orderBy=basdtVal::asc&searchLimit=1')
                .then(res => {
                    commit('LOGO_FILE', res.data.data[0]);
                });
        },
        SET_PAGE_NM({commit}, pageNm) {
            commit('PAGE_NM', pageNm);
        },
        SET_PAGE_CATE({commit}, pageCate) {
            commit('PAGE_CATE', pageCate);
        },
        SET_IS_LOADER({commit}, isLoader) {
            commit('IS_LOADER', isLoader);
        },
        SET_WINDOW_WIDTH_SIZE({commit}, windowWidthSize) {
            commit('WINDOW_WIDTH_SIZE', windowWidthSize);
        },
        SET_SHOW_BTM({commit}, showBtm) {
            commit('SHOW_BTM', showBtm);
        },
    },
};
